<template>
  <div class="component-content configuration-frame">
    <div class="component-content-scroll">
      <div class="uppercase xs-text bold">Select your frame details</div>
      <ul>
        <li
          class="xs-text uppercase"
          :class="{
            active:
              'frame-finish' == this.subSteps[this.currentSubStep].activeItem,
          }"
          v-on:click="goToFrameFinish"
        >
          Frame finish
        </li>
        <li
          :class="{
            active:
              'frame-title' == this.subSteps[this.currentSubStep].activeItem,
          }"
          class="xs-text uppercase"
          v-on:click="goToFrameTitle"
        >
          Personal title
        </li>
      </ul>
      <component
        v-bind:is="getContent"
        :results="results"
        :components="components"
        v-on:update-title-font="updateTitleFont"
        v-on:update-title-text="updateTitleText"
        v-on:set-frame-finish="updateFrameFinish"
      ></component>
    </div>
    <div class="buttonset" :class="{ flexend: currentSubStep == 0 }">
      <button
        :style="{ display: currentSubStep == 0 ? 'none' : 'block' }"
        class="btn btn-outline-dark back-button"
        v-on:click="goBack"
      >
        back
      </button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import frameFinish from "./sub-components/frame-finish.vue";
import frameTitleFont from "./sub-components/frame-title-font.vue";
import frameTitleText from "./sub-components/frame-title-text.vue";

Vue.component("frame-finish", frameFinish);
Vue.component("frame-title-font", frameTitleFont);
Vue.component("frame-title-text", frameTitleText);

export default {
  name: "configuration-frame",
  data() {
    return {
      subSteps: [
        {
          name: "frame-finish",
          template: "frame-finish",
          activeItem: "frame-finish",
        },
        {
          name: "frame-title-font",
          template: "frame-title-font",
          activeItem: "frame-title",
        },
        {
          name: "frame-title-text",
          template: "frame-title-text",
          activeItem: "frame-title",
        },
      ],
      currentSubStep: 0,
    };
  },
  computed: {
    getContent: function () {
      return this.subSteps[this.currentSubStep].template;
    },
  },
  props: ["bike", "configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.currentSubStep==0 && this.results.frame.finish==null) {
        this.$emit('set-error', 'Please select a frame finish')
        return false;
      }
      if (this.currentSubStep==2 && this.results.frame.title.text==null) {
        this.$emit('set-error', 'Enter some text');
        return false;
      }
      if (this.currentSubStep < this.subSteps.length - 1) {
        if (this.currentSubStep==1 && this.results.frame.title.family==null) {
          this.$emit("go-next");
        }
        this.currentSubStep++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentSubStep > 0) {
        this.currentSubStep--;
      } else {
        this.$emit("go-back");
      }
    },
    goToFrameFinish: function () {
      this.currentSubStep = 0;
    },
    goToFrameTitle: function () {
      this.currentSubStep = 1;
    },
    updateTitleFont: function (e) {
      this.$emit("update-title-font", e);
    },
    updateTitleText: function (e) {
      this.$emit("update-title-text", e);
    },
    updateFrameFinish: function (e) {
      this.$emit("set-frame-finish", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-frame {
  ul {
    list-style: none;
    padding: 0;
    margin-top: 20px;
    li {
      display: inline-block;
      margin-right: 25px;
      text-transform: uppercase;
      color: #888;
      &.active {
        font-weight: 600;
        position: relative;
        color: black;
        &::after {
          content: "";
          width: 100%;
          border-bottom: 1px solid black;
          position: absolute;
          left: 0;
          bottom: -10px;
        }
      }
    }
  }
}
</style>

